/**
 * FilterSearch — the keyword search input used across admin list surfaces
 * (Partners queue, User Management). Icon + search field + clear affordance.
 * Composes with FilterPills + the surface's sort.
 *
 * Documented in `Docs/Technical/portal-staff-component-library.md`.
 */
export interface FilterSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export function FilterSearch({
  value,
  onChange,
  placeholder = 'Search…',
  ariaLabel = 'Search',
}: FilterSearchProps) {
  return (
    <label className="portal-filter-search">
      <span className="portal-filter-search-icon" aria-hidden="true">🔍</span>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {value && (
        <button
          type="button"
          className="portal-filter-search-clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          ×
        </button>
      )}
    </label>
  );
}
